import React from "react";
import DataList from "components/datatable/DataList";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import { RuleRequired } from "utils/MyUtils";
import { boolText, showEmpty } from "features/kms/system/SystemPageUtils";
import { formatKegiatanDate } from "./KegiatanPageUtils";

export default function PelatihanManagementPage() {
  const [, , , axiosFetch] = useAxiosFunction();
  const [kejuaraanResp] = useAxios({ method: "GET", url: "/references/kejuaraan", auth: true });
  const kejuaraanOptions = Array.isArray(kejuaraanResp?.data) ? kejuaraanResp.data : [];
  const formatWaktu = (item) => {
    const awal = formatKegiatanDate(item?.tanggal_awal);
    const akhir = formatKegiatanDate(item?.tanggal_akhir);
    return [awal, akhir].filter(Boolean).join(" - ");
  };
  const statusAktifOptions = [
    { id: "true", nama: "Aktif" },
    { id: "false", nama: "Nonaktif" },
  ];

  const coltype = {
    id_pelatihan: { type: "hidden", name: "id_pelatihan" },
    nama_pelatihan: {
      label: "Nama Pelatihan",
      type: "text",
      name: "nama_pelatihan",
      colsize: 12,
      validation: RuleRequired,
      width: 240,
    },
    id_kejuaraan: {
      label: "Kejuaraan",
      type: "dropdown",
      name: "id_kejuaraan",
      colsize: 12,
      validation: RuleRequired,
      options: kejuaraanOptions,
      valueId: "id_kejuaraan",
      labelId: "nama",
      placeholder: "-Pilih Kejuaraan-",
      width: 220,
    },
    kejuaraan_name: {
      label: "Kejuaraan",
      renderFunc: (val) => showEmpty(val),
      width: 220,
    },
    tempat_kegiatan: {
      label: "Tempat Kegiatan",
      type: "text",
      name: "tempat_kegiatan",
      colsize: 12,
      validation: RuleRequired,
      width: 140,
    },
    penanggung_jawab: {
      label: "Penanggung Jawab",
      type: "text",
      name: "penanggung_jawab",
      colsize: 12,
      validation: RuleRequired,
      width: 170,
    },
    tanggal_awal: {
      label: "Tanggal Awal",
      type: "date",
      name: "tanggal_awal",
      colsize: 6,
      validation: RuleRequired,
      renderFunc: (val) => showEmpty(formatKegiatanDate(val)),
      renderExportFunc: (val) => showEmpty(formatKegiatanDate(val)),
      width: 130,
      align: "center",
    },
    tanggal_akhir: {
      label: "Tanggal Akhir",
      type: "date",
      name: "tanggal_akhir",
      colsize: 6,
      validation: RuleRequired,
      renderFunc: (val) => showEmpty(formatKegiatanDate(val)),
      renderExportFunc: (val) => showEmpty(formatKegiatanDate(val)),
      width: 130,
      align: "center",
    },
    waktu: {
      label: "Waktu",
      renderFunc: (val, col, item) => showEmpty(formatWaktu(item)),
      renderExportFunc: (val, col, item) => showEmpty(formatWaktu(item)),
      width: 190,
      align: "center",
    },
    aktif: {
      label: "Status",
      type: "checkbox",
      name: "aktif",
      renderFunc: (val) => boolText(val),
      renderExportFunc: (val) => boolText(val),
      colsize: 3,
      width: 90,
      align: "center",
    },
    action: { label: "Aksi", align: "center", width: 100 },
  };

  const columnsForm = [
    "nama_pelatihan",
    "id_kejuaraan",
    "tempat_kegiatan",
    "penanggung_jawab",
    "tanggal_awal",
    "tanggal_akhir",
  ];

  const saveHandle = async (form, defaultValue = {}) => {
    const id = form?.id_pelatihan || defaultValue?.id_pelatihan || "";
    return axiosFetch({
      method: id ? "PUT" : "POST",
      url: id ? `/kegiatan/pelatihan/${id}` : "/kegiatan/pelatihan",
      auth: true,
      data: {
        nama_pelatihan: form?.nama_pelatihan || "",
        id_kejuaraan: form?.id_kejuaraan || "",
        tempat_kegiatan: form?.tempat_kegiatan || "",
        penanggung_jawab: form?.penanggung_jawab || "",
        tanggal_awal: form?.tanggal_awal || "",
        tanggal_akhir: form?.tanggal_akhir || "",
      },
    });
  };

  return (
    <DataList
      title="Pelatihan"
      coltype={coltype}
      dlist={{
        url: "/kegiatan/pelatihan",
        columns: [
          "no",
          "nama_pelatihan",
          "kejuaraan_name",
          "tempat_kegiatan",
          "penanggung_jawab",
          "waktu",
          "aktif",
          "action",
        ],
        filter: [
          { dtype: "q", name: "q", colsize: 3 },
          {
            dtype: "dropdown",
            name: "id_kejuaraan",
            label: "Kejuaraan",
            colsize: 3,
            options: kejuaraanOptions,
            valueId: "id_kejuaraan",
            labelId: "nama",
            placeholder: "-Semua Kejuaraan-",
          },
          {
            dtype: "dropdown",
            name: "aktif",
            label: "Status",
            colsize: 3,
            options: statusAktifOptions,
            valueId: "id",
            labelId: "nama",
            placeholder: "-Semua Status-",
          },
        ],
        sort_by: ["nama_pelatihan", "kejuaraan_name", "tempat_kegiatan", "penanggung_jawab"],
      }}
      addconfig={{
        columns: columnsForm,
        title: "Tambah Pelatihan",
        label_tool: "Tambah Pelatihan",
        saveHandle,
      }}
      editconfig={{
        columns: ["id_pelatihan", ...columnsForm],
        title: "Ubah Pelatihan",
        url: "/kegiatan/pelatihan",
        urlitem: "/kegiatan/pelatihan",
        cellid: "id_pelatihan",
        saveHandle,
      }}
      delconfig={{
        url: "/kegiatan/pelatihan",
        cellid: "id_pelatihan",
        cellname: "nama_pelatihan",
      }}
      activateconfig={{
        url: "/kegiatan/pelatihan",
        cellid: "id_pelatihan",
        cellname: "nama_pelatihan",
        cellactivate: "aktif",
        labelactivate: "Aktifkan",
        labelinactivate: "Non-aktifkan",
        cfmactivate: "mengaktifkan",
        cfminactivate: "menonaktifkan",
        infoactivate: "diaktifkan",
        infoinactivate: "dinonaktifkan",
      }}
      pdflist={{ title: "Pelatihan" }}
      xlslist={{ title: "Pelatihan" }}
    />
  );
}
